const esLang = {
  title: 'Nosotros',
  aboutUs: '¿Quiénes somos?',
  mission: 'Misión',
  commitment: 'Compromiso',
  values: 'Valores'
}
const enLang = {
  title: 'About us',
  aboutUs: '¿Quiénes somos? ',
  mission: 'Mission',
  commitment: 'Commitment',
  values: 'Valores'
}

export const langTexts = {
  es: esLang,
  en: enLang
} 